import { IGetSubcontasDropDownUseCase } from "../../../presentation/useCases/read/get_subconta_dropdown_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetDropDownUseCase
 */

export class GetSubcontasDropDownUseCase implements IGetSubcontasDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getSubcontasDropDown(): Promise<DropDown[]> {
    const response = await this.repository.getSubcontasDropDown();
    return response
  }

}